import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getAuthToken } from "../../utils/auth";
import { handleApiError } from "../handleApiError";

const API_URL = process.env.REACT_APP_API_URL;

// ========================
// GET MY REVIEWS
// ========================
export const getMyReviews = createAsyncThunk(
  "review/myReviews",
  async (_, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      const res = await axios.get(`${API_URL}/review/my-reviews`, {
        headers: { Authorization: `${token}` },
      });
      return res.data.data || [];
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ========================
// CREATE REVIEW
// ========================
export const createReview = createAsyncThunk(
  "review/create",
  async (data, { rejectWithValue }) => {
    try {
      // console.log(data);
      const token = getAuthToken();
      const res = await axios.post(`${API_URL}/review`, data, {
        headers: { Authorization: `${token}` },
      });
      // console.log(res);
      return res.data.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ========================
// UPDATE REVIEW
// ========================
export const updateReview = createAsyncThunk(
  "review/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      const res = await axios.put(`${API_URL}/review/${id}`, data, {
        headers: { Authorization: `${token}` },
      });
      return res.data.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ========================
// DELETE REVIEW
// ========================
export const deleteReview = createAsyncThunk(
  "review/delete",
  async (id, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      await axios.delete(`${API_URL}/review/${id}`, {
        headers: { Authorization: `${token}` },
      });
      return id;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ========================
// ADMIN – GET ALL REVIEWS
// ========================
export const getAllReviewsAdmin = createAsyncThunk(
  "review/admin/all",
  async ({ page = 1, limit = 10, search } = {}, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      const res = await axios.get(`${API_URL}/review/admin/all`, {
        params: { page, limit, search },
        headers: { Authorization: `${token}` },
      });
      return res.data.data || [];
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ========================
// ADMIN – TOGGLE REVIEW STATUS
// ========================
export const toggleReviewStatus = createAsyncThunk(
  "review/admin/toggle",
  async (id, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      const res = await axios.patch(
        `${API_URL}/review/admin/toggle/${id}`,
        {},
        {
          headers: { Authorization: `${token}` },
        },
      );
      return res.data.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
